import React, { useState } from 'react'
import { InvoiceBatchFilters } from './filters'
import { InvoiceBatchParams, previewInvoiceBatch } from '../../../api'
import { InvoiceBatchSummary } from '../../../models'
import { InvoiceBatchSummary as Summary } from './summary'
import { Loading } from 'components/common'

export function InvoiceBatchPreview() {
    const [filters, setFilters] = useState<InvoiceBatchParams>()
    const [summary, setSummary] = useState<InvoiceBatchSummary>()
    const [isLoading, setIsLoading] = useState(false)

    const updateFilters = <K extends keyof InvoiceBatchParams>(filterName: K, newValue: InvoiceBatchParams[K]) => {
        let updated: InvoiceBatchParams = {
            ...filters,
            [filterName]: newValue,
        }

        setFilters(updated)
    }

    async function getPreview() {
        setIsLoading(true)

        try {
            const response = await previewInvoiceBatch(filters)
            const invoiceBatchSummary = new InvoiceBatchSummary(response.data)

            setSummary(invoiceBatchSummary)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className='container card'>
            <div className='card-body'>
                <div className='row'>
                    <div className='col'>
                        <h3>Preview Batch</h3>
                        <InvoiceBatchFilters updateFilters={updateFilters} />
                    </div>
                </div>
                <div className='row mt-3'>
                    <div className='col d-flex justify-content-center align-items-center'>
                        <button
                            onClick={() => {
                                getPreview()
                            }}
                            disabled={isLoading}
                            className='btn btn-primary mt-3'>
                            Submit {isLoading && <Loading sm={true} />}
                        </button>
                    </div>
                </div>
                {summary && !isLoading && (
                    <div className='row'>
                        <Summary
                            locale={summary.locale}
                            summary={summary} />
                    </div>
                )}
            </div>
        </div>
    )
}
